import * as Yup from "yup";

// text string is used as a key to fetch intl message
const MeetingParticipantsFormValidationSchema = () => {
  return Yup.object().shape({
    staffParticipants: Yup.array().min(1),
    participants: Yup.array().when(
      ["staffParticipants", "externalParticipants"],
      {
        is: (staffArray: [], externalArray: []) =>
          (Array.isArray(staffArray) && staffArray.length > 1) ||
          (Array.isArray(externalArray) && externalArray.length > 0),
        then: () => Yup.array().notRequired(),
        otherwise: () => Yup.array().min(1),
      }
    ),
  });
};

export default MeetingParticipantsFormValidationSchema;
